import * as React from 'react';
import { MathFunctions } from '../../functions/math';
import * as _ from 'lodash';
import { IFullPaginationOptions } from './pagination';

interface IPageNumber {
    number: number;
    active: boolean;
}

export interface IPageButton extends IPageNumber {
    isLeftMost: boolean;
    isRightMost: boolean;
    isEllipsis: boolean;
    numberOfPages: number;
}

export interface IPagingProps {
    numberOfButtonsToShow: number;
    paging: IFullPaginationOptions;
    onPageSelect(page: number): void;
}

export interface IPageButtonProps {
    page: IPageButton;
    key: any;
    onPageSelect(page: number): void;
}

/// <summary>
/// Individual page buttons
/// </summary>
export class PageButton extends React.Component<IPageButtonProps, any> {
    constructor(props) {
        super(props);

        if (props.queryCurrentPage) {
            props.pageSelectProps(props.queryCurrentPage);
        }
    }

    /// <summary>
    /// Determines CSS class names for the button
    /// </summary>
    /// <returns>Css classes</returns>
    GetClasses() {
        var activeOrellipsis = this.props.page.active ? 'selected '
            : this.props.page.isEllipsis ? 'ellipsis '
                : '';

        return activeOrellipsis + 'adage-search-pagination-link ' + 'adage-search-pagination-buttons-item-' + this.GetContent().toString();
    }

    /// <summary>
    /// Determines text content to display for the button
    /// </summary>
    /// <returns>Content text</returns>
    GetContent() {
        return this.props.page.isEllipsis ? '...'
            : this.props.page.isLeftMost ? 1
                : this.props.page.isRightMost ? this.props.page.numberOfPages
                    : this.props.page.number;
    }

    GetAriaContent() {
        return this.props.page.active ? "Current Page, Page" : "Page";
    }

    render() {
        return (
            <li className="adage-search-pagination-list-item" data-id="pageLinks">
                <a href="#" className={this.GetClasses()} onClick={() => this.props.page.isEllipsis || this.props.page.active ? false : this.props.onPageSelect(this.props.page.number)}>
                    <span className="visually-hidden">
                        {this.GetAriaContent()}
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: this.GetContent().toString() }} />
                </a>
            </li>
        );
    }
}

/// <summary>
/// Creates and renders collection of page buttons
/// </summary>
export class Paging extends React.Component<IPagingProps, any> {
    /// <summary>
    /// Creates collection of page buttons to render
    /// </summary>
    /// <returns>Page buttons</returns>
    GetPages() {
        const numberOfPages = this.props.paging.totalPages;
        const pagesMiddle = Math.ceil(this.props.numberOfButtonsToShow / 2);
        //Create list of page number objects
        var pageNumbers = [];
        for (var i = 0; i < (numberOfPages); i++) {
            pageNumbers[i] = { number: i + 1, active: (i + 1) === this.props.paging.pageNumber } as IPageNumber;
        }

        //Filter list to only the numbers we will display
        const centered = MathFunctions.getRangeCenteredAt(this.props.paging.pageNumber, this.props.numberOfButtonsToShow, pageNumbers);

        return centered
            .map((page, i) => {
                //Calculate page-specific attributes
                const isLeftMost = i === 0 && page.number !== 1;
                const isRightMost = page.number !== numberOfPages && page.number !== (numberOfPages - 1) && (i === centered.length - 1);

                const isLeftEllipsis = ((numberOfPages > this.props.numberOfButtonsToShow) && (this.props.paging.pageNumber > pagesMiddle)) && i === 1;
                const isRightEllipsis = ((numberOfPages > this.props.numberOfButtonsToShow) && ((numberOfPages - this.props.paging.pageNumber) > pagesMiddle)) && i === centered.length - 2;
                const isEllipsis = isLeftEllipsis || isRightEllipsis;

                const number = isLeftMost ? 1
                    : isRightMost ? numberOfPages
                        : page.number;

                return _.assign(page, {
                    isLeftMost,
                    isRightMost,
                    number,
                    numberOfPages,
                    isEllipsis
                }) as IPageButton;
            });
    }

    renderPages = (page, i) => {
        return <PageButton
            page={page}
            key={i}
            onPageSelect={this.props.onPageSelect} />;
    }

    render() {
        return this.GetPages().map(this.renderPages);
    }
}